/* Responsibility: Apply formatting to data from server, preparing for view. */

import distanceFormatter from '../../filters/distanceFormatter.js';
import fn from '../../lib/fn.js';
import { thousandSeparated } from '../../lib/formatting.js';

const T = FINN.travel;
const maxRating = 5;

const timeFormat = 'HH:mm:ss';
const dateFormat = 'dd D. MMM';
const yearFormat = 'dd D. MMMM YYYY';

function formatPrice(price) {
    return `${thousandSeparated(price)} kr`;
}

function formatDuration(duration, tripType) {
    if (tripType === 'ONE_WAY_FLIGHT') {
        return '';
    }
    return duration + (duration > 1 ? ' dager' : ' dag');
}

function formatDepartureDate(date) {
    const lowerCased = moment(date, 'YYYY-MM-DD').format(dateFormat).toLowerCase();
    return lowerCased.charAt(0).toUpperCase() + lowerCased.slice(1);
}

function formatDateWithYear(date) {
    const lowerCased = moment(date, 'YYYY-MM-DD').format(yearFormat).toLowerCase();
    return lowerCased.charAt(0).toUpperCase() + lowerCased.slice(1);
}

function formatDepartureTime(date) {
    const time = moment(date).format(timeFormat);
    if (time === '23:59:59') {
        return T.lang.missing_time();
    }
    return time.substring(0, 5);
}

function calculatePercentageFromRating(rating) {
    return (rating / maxRating) * 100;
}

function formatOffer(offer) {
    const unformattedDate = offer.outboundDepartureTime;
    offer.durationWithDays = formatDuration(offer.duration, offer.tripType);
    offer.departureDate = formatDepartureDate(unformattedDate);
    offer.departureDateYear = formatDateWithYear(unformattedDate);
    offer.departureTime = formatDepartureTime(unformattedDate);
    offer.flightType = offer.tripType === 'ONE_WAY_FLIGHT' ? 'En vei' : 'Tur/retur';
    if (offer.tripType === 'ONE_WAY_FLIGHT' || offer.tripType === 'FLIGHT_ONLY') {
        offer.flightOnly = 'true';
        offer.hotelName = 'Kun fly';
    }
    if (offer.rating > 0) {
        offer.ratingPercentage = calculatePercentageFromRating(offer.rating);
    }
    offer.regionAndCountrySeparator = offer.country && offer.region ? ',' : '';
    offer.destinationAndRegionSeparator = offer.destination && offer.country ? ',' : '';
    if (offer.distances && offer.distances.beach >= 0) {
        offer.formattedDistanceToBeach = distanceFormatter.format(offer.distances.beach);
    }
    if (offer.distances && offer.distances.city >= 0) {
        offer.formattedDistanceToCity = distanceFormatter.format(offer.distances.city);
    }
    offer.formattedPrice = formatPrice(offer.price);
}

export default function prepareLmsResultsForView(data) {
    fn.forEach(data.offers, formatOffer);
}
